<template>
  <div id="printtest"></div>
  <div v-show="showDropdown" ref="dropdown"
    class="project-filter-dropdown z-20 border-gray-500 absolute p-2 bg-white max-h-96 overflow-y-auto"
    @click="selectDropdown"></div>
  <Transition>
    <TopBanner :mode="bannerMode" :text="bannerText" v-if="bannerText" />
  </Transition>
  <Spinner v-if="loading" />
  <div class="admin-page admin-page--centered relative"
    @click="generalClick">
    <Transition>
      <JobModal v-if="selectedJob" :job="selectedJob" @close="selectedJob = false" :users="allUsers"
        @changeUser="changeUser" />
    </Transition>
    <Transition>
      <ContactDetails v-if="contactDetails" :token="token" :job="contactDetails" @close="contactDetails = false" />
    </Transition>
    <div class="relative w-full text-center print:text-xxs">
      <div class="relative w-full text-center">
        <div class="admin-page-header">
          <div class="admin-page-heading">
            <h1 class="admin-page-title">Auftragsplanung</h1>
            <select class="font-bold text-xl bg-white border border-gray-300 rounded p-1 print:hidden"
              v-model="currentMode" @keydown.enter.prevent="getJobs()">
              <option>Messebasis</option>
              <option>Messestw</option>
              <option>Veranstaltung</option>
              <option>Objektschutz</option>
              <option>Global</option>
              <option>App-Ansicht</option>
            </select>
          </div>
          <div class="hidden lg:block print:hidden">
            <div class="admin-action-bar">
              <button v-if="jobs.length > 0 && billingMode" class="admin-button--secondary" @click="printPage()">
                Drucken
              </button>
              <button v-if="jobs.filter(j => j.new).length > 1" class="admin-button--danger" @click="deleteAllNewJobs()">
                Alle Löschen
              </button>
              <button v-if="jobs.filter(j => j.new).length > 1" class="admin-button--primary" @click="saveAllNewJobs">
                Alle Speichern
              </button>
              <button v-if="stats.permissions.admin" class="admin-button--primary" @click="showImportModal = true">
                <i class="fa fa-upload mr-2"></i>Aufträge importieren
              </button>
              <button v-if="stats.permissions.admin" class="admin-button--secondary" @click="showTrashcanModal = true">
                <i class="fa fa-trash mr-2"></i>Papierkorb
              </button>
            </div>
          </div>
        </div>
        <section class="admin-panel mt-5 w-full text-left">
          <div class="admin-panel__body">
          <div class="flex flex-wrap items-end gap-2">
          <div class="relative shrink-0">
            <span class="block font-bold">Projekt</span>
            <div class="absolute right-4 text-2xl bottom-3 text-gray-500 cursor-pointer" @click="filter.project = ''">
              <i class="fa fa-xmark" />
            </div>
            <input size="1" v-model="filter.project" placeholder="Projektname"
              @click="filterDropdown($event, allContracts.map ? allContracts.map(el => el.name) : [], { type: 'project' })"
              class="dropdown border-b-2 w-64 sm:w-96 p-2 border-gray-500"
              @input="filterDropdown($event, allContracts.map ? allContracts.map(el => el.name) : [], { type: 'project' })"
              @keydown.enter.prevent="getJobs()" />
          </div>
          <div class="flex flex-wrap items-end gap-2 shrink-0">
            <div class="acwrapper shrink-0">
              <span class="block font-bold">Startdatum ab</span>
              <input size="1" type="date" v-model="filter.start" class="border-b-2 w-36 shrink-0 border-gray-500"
                @keydown.enter.prevent="getJobs()" />
            </div>
            <div class="shrink-0">
              <span class="block font-bold">Startdatum bis</span>
              <input size="1" type="date" v-model="filter.end" class="border-b-2 w-36 shrink-0 border-gray-500"
                @keydown.enter.prevent="getJobs()" />
            </div>
          </div>
          <button :class="isSearchDirty ? 'search-button--pending' : 'admin-button--secondary'"
            class="shrink-0"
            @click="getJobs()">Suchen</button>
          <button class="admin-button--secondary shrink-0"
            @click="resetFilter()">Filter zurücksetzen</button>
          <button class="admin-button--ghost admin-button--sm shrink-0" @click="showBedienung = !showBedienung">
            <i class="fa" :class="showBedienung ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
            Bedienung
          </button>
          </div>
          <div v-if="meta.results == 1000"><span class="text-red-500 font-bold font-xl pt-3">Maximale Anzahl an
              Ergebnisse erreicht. Bitte Ergebnis durch Filter weiter eingrenzen!</span></div>

          <!-- Usage hints, collapsed by default -->
          <div v-if="showBedienung" class="mt-2">
              <span class="block"><b>STRG+Klick</b>: Zeile kopieren</span>
              <span class="block"><b>ALT+Klick</b>: Zeile aus Ansicht löschen (nicht in Navision)</span>
              <span class="block"><b>Doppelklick auf grüne Zeile</b>: Zeile in Navision speichern</span>
              <span class="block"><b>Mehrere Zellen einer Spalte markieren + Wert eingeben</b>: wird auf alle
                markierten Zeilen angewendet</span>
              <span class="block"><b>Shift+Klick</b>: Zellwert in Zwischenablage kopieren</span>
              <span class="block"><b>Klick auf markierte Zelle</b>: Zelle bearbeiten</span>
              <span class="block"><b>Trichter-Icon in Spaltenüberschrift</b>: Spalte filtern</span>
              <span class="block text-red-600"><b>Lfd_Nr</b>: "-" für leere Werte</span>
            </div>
          </div>
        </section>
        <div v-if="searched" class="text-left mt-5">
          <span class="font-bold">Aufträge gefunden: {{ meta.results }}</span><span class="font-bold"> | Summe
            Soll-Stunden: {{ formatFloat(meta.sumSollStunden) }}</span><span class="font-bold"> | Summe
              Ist-Stunden: {{ formatFloat(meta.sumIstStunden) }}</span><span class="font-bold"> | Summe
                geprüfter Ist-Stunden: {{ meta.sumBillableHours }}</span><span class="font-bold"> | Summe Strafen: {{
            meta.sumPenalties }}
            €</span>
        </div>
        <div class="flex justify-end gap-2 mt-3 print:hidden">
          <JssColumnManager :columns="columnManagerColumns" :order="columnOrder" :hidden="columnHidden"
            @change="onColumnsChange" />
          <button v-if="jobs.length > 0" class="admin-button--secondary" @click="exportView()">
            <i class="fa fa-file-excel mr-1"></i>Excel Export
          </button>
        </div>
        <div ref="spreadsheetContainer" class="jss-container rounded-lg shadow-lg mt-2 w-full print:hidden"></div>
        <div v-if="searched && jobs.length === 0" class="text-gray-500 p-8 text-center font-bold print:hidden">
          Keine Aufträge gefunden.
        </div>
        <button
          class="admin-button--primary mt-3"
          @click="addJob()">Job
          hinzufügen</button>
      </div>
    </div>
  </div>
  <JobImportModal v-if="showImportModal" :allUsers="allUsers" :allContracts="allContracts" :allCompanies="allCompanies"
    :allServicetypes="allServicetypes" :currentJobs="jobs" :currentMode="currentMode" @close="showImportModal = false"
    @import="handleJobImport" />
  <TrashcanModal v-if="showTrashcanModal" :token="token" :isAdmin="stats.permissions.admin"
    @close="showTrashcanModal = false" @restored="handleJobRestored" />
</template>

<script>
import CASP from "../../CASP";
import { useCookies } from "vue3-cookies";
import JobModal from "@/components/JobModal.vue";
import ContactDetails from "@/components/ContactDetails.vue";
import Spinner from "@/components/Spinner";
import TopBanner from "@/components/TopBanner";
import JobImportModal from "@/components/JobImportModal.vue";
import TrashcanModal from "@/components/TrashcanModal.vue";
import views from "@/lib/views.json";
import jspreadsheet from "jspreadsheet-ce";
import "jspreadsheet-ce/dist/jspreadsheet.css";
import "jsuites/dist/jsuites.css";
import JssColumnManager from "@/components/JssColumnManager.vue";
import { exportJssView } from "@/lib/jssExport";
import { applyColumnSettings, installAutocompleteFilters, removeAutocompleteFilters, stickFilterRow } from "@/lib/jssColumns";
import { createRowHighlighter } from "@/lib/jssRowHighlight";
import { isSearchDirty } from "@/lib/jssSearchDirty";
import { installAppendOnlyRowLoading } from "@/lib/jssAppendOnlyRows";
import { sortJssRows } from "@/lib/jssSort";
import { applyEmployeeAssignmentResponse, extractPersnr } from "@/lib/employeeAssignment";
import { employeeReadinessTooltip } from "@/lib/employeeReadinessDisplay";

let in3Days = new Date()
in3Days.setDate(in3Days.getDate() + 3)

// ─── Fields that are edited via an autocomplete dropdown ─────────────
// The dropdown source is resolved per row by getDropdownSource().
const DROPDOWN_FIELDS = [
  "Vertragsbeschreibung",
  "Einsatzort_Beschreibung",
  "Einsatzstelle_Beschreibung",
  "Firmenkurzel",
  "Leistungsart_Code",
  "Rubrikencode",
  "Mitarbeiternr"
];

// Fields whose dropdown source depends on other values of the same job.
const DEPENDENT_DROPDOWN_FIELDS = [
  "Einsatzort_Beschreibung",
  "Einsatzstelle_Beschreibung",
  "Rubrikencode"
];

function isoToDisplay(value) {
  if (!value) return '';
  const text = String(value);
  const fullYear = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (fullYear) return `${fullYear[3]}.${fullYear[2]}.${fullYear[1]}`;
  const shortYear = text.match(/^(\d{2})-(\d{2})-(\d{2})/);
  return shortYear ? `${shortYear[3]}.${shortYear[2]}.20${shortYear[1]}` : text;
}

function displayToIso(value) {
  if (!value) return '';
  const text = String(value).trim();
  let match = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T].*)?$/);
  if (match) return `${match[1]}-${match[2]}-${match[3]}`;
  match = text.match(/^(\d{2})-(\d{2})-(\d{2})(?:[ T].*)?$/);
  if (match) return `20${match[1]}-${match[2]}-${match[3]}`;
  match = text.match(/^(\d{1,2})\.(\d{1,2})\.(\d{2,4})(?:[ T].*)?$/);
  if (!match) return text;
  let [, day, month, year] = match;
  if (year.length === 2) year = '20' + year;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}

function weekdayFromDate(value) {
  const isoDate = displayToIso(value);
  const match = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return '';

  const [, year, month, day] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return ['SO', 'MO', 'DI', 'MI', 'DO', 'FR', 'SA'][date.getDay()];
}

function isValidDisplayDate(value) {
  const text = String(value == null ? '' : value).trim();
  if (!text) return true;
  const match = text.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (!match) return false;
  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  return year >= 1000 && month >= 1 && month <= 12 && day >= 1 && day <= new Date(year, month, 0).getDate();
}

function formatDateInput(value) {
  const text = String(value == null ? '' : value).trim();
  if (!text) return '';
  if (!/^[\d.]*$/.test(text)) return null;
  const digits = text.replace(/\./g, '');
  if (!/^\d{0,8}$/.test(digits)) return null;
  let formatted = digits.slice(0, 2);
  if (digits.length >= 2) formatted += '.';
  if (digits.length > 2) formatted += digits.slice(2, 4);
  if (digits.length >= 4) formatted += '.';
  if (digits.length > 4) formatted += digits.slice(4);
  return formatted;
}

function formatDateEditor(input) {
  const cursor = input.selectionStart == null ? input.value.length : input.selectionStart;
  const digitsBeforeCursor = input.value.slice(0, cursor).replace(/\./g, '').length;
  const formatted = formatDateInput(input.value);
  if (formatted === null || formatted === input.value) return;
  input.value = formatted;
  const separators = (digitsBeforeCursor >= 2 ? 1 : 0) + (digitsBeforeCursor >= 4 ? 1 : 0);
  const position = Math.min(formatted.length, digitsBeforeCursor + separators);
  input.setSelectionRange(position, position);
}

export default {
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  name: "AdminjobplanningJSS",
  components: { ContactDetails, JobModal, Spinner, TopBanner, JobImportModal, TrashcanModal, JssColumnManager },
  data() {
    return {
      token: "",
      currentMode: "Messebasis",
      searchSnapshot: null,
      modes: views,
      filter: {
        project: "",
        start: new Date().toISOString().split("T")[0],
        end: in3Days.toISOString().split("T")[0]
      },
      tableFilters: {},
      tableFilterTimer: null,
      printing: false,
      loading: false,
      bannerText: "",
      bannerMode: "success",
      showImportModal: false,
      showTrashcanModal: false,
      allProjects: [],
      allCompanies: [],
      allServicetypes: [],
      allContracts: {},
      allEmployees: {},
      employeeReadinessByPersnr: {},
      employeeFirmenkurzelMap: {},
      contactDetails: false,
      showDropdown: false,
      showActions: false,
      showBedienung: false,
      selectedJob: false,
      searched: false,
      dropdownRef: {},
      jobs: [],
      contracts: [],
      billingMode: false,
      meta: {
        results: 0,
        sumBillableHours: 0,
        sumPenalties: 0,
      },
      stats: { permissions: {} },
      newId: 0,
      queryCount: 0,
      columnWidths: {},
      // jspreadsheet instance + listeners
      jssInstance: null,
      appendOnlyRowLoadingCleanup: null,
      sortState: null,
      gridClickHandler: null,
      gridDblClickHandler: null,
      connection: null,
      rowHighlighter: null,
      // Columns used at render time — stored to avoid index mismatches
      renderedColumns: [],
      // Suppress onchange while we write cell values programmatically
      suppressChange: false,
      // Last single-column multi-row selection ("marked" cells, like the
      // old view's drag-to-mark feature). Kept alive while the user clicks
      // inside it, cleared when a selection outside it is made.
      markedRange: null,
      // Per-user column order/visibility per view, loaded from the backend:
      // { [viewKey]: { order: [field...], hidden: [field...] } }
      viewSettings: {}
    };
  },
  computed: {
    isSearchDirty() {
      return isSearchDirty(this.searchSnapshot, this.currentMode, this.filter);
    },
    today: function () {
      let d = new Date().toISOString().split("T")[0].split("-");
      return d[2] + "." + d[1] + "." + d[0];
    },
    datestamp: function () {
      return new Date().toISOString().split("T")[0] + "00:00:00";
    },
    hasLfdColumn: function () {
      if (!this.modes[this.currentMode]) return false;
      return this.modes[this.currentMode].some(c => c.column === "Lfd_Nr");
    },
    // Persistence key for the current table view (selected mode)
    viewKey: function () {
      return "adminjobplanning-" + this.currentMode;
    },
    // All manageable columns of the current mode (default order) for the
    // Spalten manager — the pinned Aktionen column is not listed.
    columnManagerColumns: function () {
      return (this.modes[this.currentMode] || [])
        .map(col => ({ field: col.column, title: col.name }));
    },
    columnOrder: function () {
      const saved = this.viewSettings[this.viewKey];
      return (saved && saved.order) || [];
    },
    columnHidden: function () {
      const saved = this.viewSettings[this.viewKey];
      return (saved && saved.hidden) || [];
    }
  },
  methods: {
    // ═══════════════════════════════════════════════════════════════════
    // Function: handleJobImport(importedJobs)
    // Adds jobs imported via JobImportModal as new (unsaved) rows. Imported
    // rows go through the same dependent-field rules as edited grid rows
    // before they are rendered.
    // ═══════════════════════════════════════════════════════════════════
    handleJobImport(importedJobs) {
      importedJobs.forEach(job => {
        job.id = "new" + this.newId;
        this.newId++;
        this.jobs.push(job);
      });
      importedJobs.forEach(job => this.applyImportedJobRules(job));
      this.renderGrid();
      this.bannerMode = "success";
      this.bannerText = `${importedJobs.length} Aufträge erfolgreich importiert`;
      setTimeout(() => {
        this.bannerText = "";
      }, 3000);
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: applyImportedJobRules(job)
    // Imported values are already parsed and validated by JobImportModal,
    // but they still need the side effects that a user gets when editing a
    // row manually (employee names/company, contract codes, WT, dates and
    // the Messestw position).
    // ═══════════════════════════════════════════════════════════════════
    applyImportedJobRules(job) {
      this.applyImportedEmployee(job);

      // Reuse the manual contract -> location -> place cascade. Preserve
      // the imported descriptions because changing a contract manually can
      // clear dependent fields before they are set again.
      const location = job.Einsatzort_Beschreibung;
      const place = job.Einsatzstelle_Beschreibung;
      if (job.Vertragsbeschreibung) {
        this.setContract(job, job.Vertragsbeschreibung);
        if (location) this.setLocation(job, location);
        if (place) this.setPlace(job, place);
      }

      // Position generation depends on all four source fields, so run the
      // same handler after all of them have been imported.
      ["Halle", "Ebene", "Gang", "Stand"].forEach(field => {
        if (Object.prototype.hasOwnProperty.call(job, field)) {
          this.onChangedInput(job, field, true);
        }
      });

      // Apply the schedule rules through the normal edit handler. Applying
      // T/N last makes the imported T/N value authoritative for Datum_bis,
      // just as it is when the user changes that field last.
      if (job.Datum_von) this.onChangedInput(job, "Datum_von", true);
      if (job.Soll_Von && job.Soll_Bis) {
        this.onChangedInput(job, "Soll_Bis", true);
      }
      if (job.Datum_von && job.T_N) {
        this.onChangedInput(job, "T_N", true);
      }
    },

    // Employee names are readonly in the grid and are normally supplied by
    // JobImportModal. Resolve them again here so imported rows remain
    // correct even when a PSL number is supplied in display format.
    applyImportedEmployee(job) {
      const importedPersnr = extractPersnr(job.Mitarbeiternr);
      let employee = null;
      if (importedPersnr) {
        employee = (this.allUsers || []).find(user =>
          String(user.persnr) === String(importedPersnr)
        ) || this.employeeReadinessByPersnr[importedPersnr];
      } else if (job.Mitarbeiter_Vorname || job.Mitarbeiter_Nachname) {
        employee = (this.allUsers || []).find(user =>
          String(user.name || "").toLowerCase() === String(job.Mitarbeiter_Vorname || "").toLowerCase() &&
          String(user.surname || "").toLowerCase() === String(job.Mitarbeiter_Nachname || "").toLowerCase()
        );
      }

      if (employee) {
        job.Mitarbeiternr = employee.persnr || importedPersnr;
        job.Mitarbeiter_Vorname = employee.name || "";
        job.Mitarbeiter_Nachname = employee.surname || "";
      } else if (importedPersnr) {
        job.Mitarbeiternr = importedPersnr;
      }

      // The row has not been rendered yet. Calling changeUser here would
      // try to synchronize the new row with the old spreadsheet instance.
      // Apply the same company side effect locally; the complete row is
      // rendered after all import rules have finished.
      const persnr = extractPersnr(job.Mitarbeiternr);
      if (persnr && this.employeeFirmenkurzelMap[persnr]) {
        job.Firmenkurzel = this.employeeFirmenkurzelMap[persnr];
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: calculateColumnWidths()
    // OLD: computed 'ch' min-widths for <th> elements.
    // NEW: computes pixel widths for jspreadsheet columns, same heuristic
    // (longest content vs. header name).
    // ═══════════════════════════════════════════════════════════════════
    calculateColumnWidths() {
      const columns = this.modes[this.currentMode];
      const widths = {};
      columns.forEach(col => {
        let maxLen = col.name.length;
        if (col.type === 'text' || col.type === 'number') {
          this.jobs.forEach(job => {
            const val = job[col.column];
            if (val != null && val !== false && val !== true) {
              const len = String(val).length;
              if (len > maxLen) maxLen = len;
            }
          });
        }
        // approx. 7px per char + padding for the filter icon
        widths[col.column] = Math.min(Math.max((maxLen + 4) * 7, 70), 320);
      });
      this.columnWidths = widths;
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: updateLfd(job)
    // Sequential numbering of Lfd_Nr starting at the given job's value.
    // Kept 1:1; afterwards the Lfd_Nr column cells are refreshed in place.
    // ═══════════════════════════════════════════════════════════════════
    async updateLfd(job) {
      let firstNumber = parseInt(job.Lfd_Nr)
      if (firstNumber) {
        for (let i = 0; i < this.jobs.length; i++) {
          this.jobs[i].Lfd_Nr = firstNumber + i
          if ((firstNumber + i).toString().length == 1) {
            this.jobs[i].Lfd_Nr = "00" + (firstNumber + i)
          } else if ((firstNumber + i).toString().length == 2) {
            this.jobs[i].Lfd_Nr = "0" + (firstNumber + i)
          }
          this.changeJob(this.jobs[i], "Lfd_Nr")
        }
        this.syncColumnCells("Lfd_Nr");
      }
    },

    findContractNames() {
      return this.allContracts.map ? this.allContracts.map(c => c.name) : []
    },
    findContractForJob(job) {
      if (!job || !Array.isArray(this.allContracts)) return null
      const description = String(job.Vertragsbeschreibung || "").trim()
      return this.allContracts.find(contract =>
        String(contract.name || "").trim() == description
      ) || this.allContracts.find(contract =>
        job.Belegnr && String(contract.code || "").trim() == String(job.Belegnr).trim()
      ) || null
    },
    getContractDebitorValue(job, field) {
      const currentValue = job && job[field]
      if (currentValue !== undefined && currentValue !== null && String(currentValue).trim() !== "") {
        return currentValue
      }

      const debitor = this.findContractForJob(job)?.debitor
      if (!debitor) return ""
      if (field === "Debitornr") return debitor.navision_nr || ""
      if (field === "Debitorname") return debitor.unternehmensname || debitor.name || ""
      return ""
    },
    findLocationNamesForJob(job) {
      return this.findContractForJob(job)?.locations.map(l => l.name) || []
    },
    findPlaceNamesForJob(job) {
      return this.findContractForJob(job)?.locations
        .find(l => l.name == job.Einsatzort_Beschreibung)?.places.map(p => p.name) || []
    },
    getDependentDropdownSource(values, currentValue) {
      const source = Array.isArray(values)
        ? values.filter(value => typeof value === "string" && value.trim() !== "")
        : []
      const normalizedCurrentValue = currentValue == null ? "" : String(currentValue).trim()
      if (normalizedCurrentValue && !source.includes(normalizedCurrentValue)) {
        source.push(normalizedCurrentValue)
      }
      return [...new Set(source)]
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: duplicateJob(job)  (STRG+Click / "K" button)
    // Copies a job as a new unsaved row below the original.
    // Kept 1:1, plus a grid re-render.
    // ═══════════════════════════════════════════════════════════════════
    duplicateJob(job) {
      if (["App-Ansicht"].includes(this.currentMode)) {
        this.showBanner("In dieser Ansicht können keine Aufträge erstellt werden", "error")
        return
      }
      let dup = JSON.parse(JSON.stringify(job))
      dup.Mitarbeiternr = ""
      dup.Mitarbeitername = ""
      dup.Mitarbeiter_Vorname = ""
      dup.Mitarbeiter_Nachname = ""
      dup.Von_Uhrzeit = ""
      dup.Bis_Uhrzeit = ""
      dup.Ist_Zeiten_geprüft = false
      dup.Bez = false
      dup.VA_Bewachung = false
      dup.VA_Normal = false
      dup.VA_Top = false
      dup.MA_Info = false
      dup.KD_Info = false
      dup.MA_gebucht = false
      dup["MA_bestätigt"] = false
      dup.Mitarbeiter_Nachname = ""
      dup.Lfd_Nr = ""
      dup.Dispo = true
      dup.new = true
      dup.id = "new" + this.newId
      delete dup.Einsatznr
      delete dup.Einsatzzeitnr
      delete dup.Soll_Stunden
      this.newId++
      this.jobs.splice(this.jobs.indexOf(job) + 1, 0, dup)
      this.renderGrid()
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: dismissJob(job)  (ALT+Click / "L" button)
    // Removes a row from the view only (not in Navision).
    // ═══════════════════════════════════════════════════════════════════
    dismissJob(job) {
      this.jobs.splice(this.jobs.indexOf(job), 1)
      this.renderGrid()
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: trashJob(job)  (trash button, admin only)
    // Moves a job to the trashcan via API.
    // Kept 1:1, plus a grid re-render.
    // ═══════════════════════════════════════════════════════════════════
    trashJob(job) {
      let vm = this;
      CASP.deleteJobToTrash(this.token, job.id, (status, res) => {
        if (status === 200) {
          vm.jobs.splice(vm.jobs.indexOf(job), 1);
          vm.renderGrid();
          vm.showBanner("Auftrag in den Papierkorb verschoben", "success");
        } else {
          vm.showBanner((res && res.desc) ? res.desc : "Fehler beim Löschen des Auftrags", "error");
        }
      });
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: handleJobRestored(restoredJob, buchBlatt)
    // Called by TrashcanModal when a job is restored.
    // Kept 1:1, plus a grid re-render.
    // ═══════════════════════════════════════════════════════════════════
    handleJobRestored(restoredJob, buchBlatt) {
      if (restoredJob) {
        // Switch to the job's Zeiterf_Buch_Blattname mode if not already there
        if (buchBlatt) {
          let modeName = buchBlatt.toLowerCase();
          modeName = modeName.charAt(0).toUpperCase() + modeName.slice(1);
          if (this.currentMode !== modeName && !["Global", "App-Ansicht"].includes(modeName)) {
            this.currentMode = modeName;
          }
        }
        // Add as a new unsaved job with -trash suffix so backend can detect it on save
        let originalId = restoredJob.id;
        restoredJob.id = originalId + "-trash";
        restoredJob.new = true;
        this.jobs.unshift(restoredJob);
        this.renderGrid();
      }
    },

    resetFilter() {
      this.filter = {
        project: "",
        start: new Date().toISOString().split("T")[0],
        end: in3Days.toISOString().split("T")[0]
      }
      this.tableFilters = {};
      this.getJobs();
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: filterDropdown(event, data, reference)
    // Autocomplete for the project filter (floating dropdown div).
    // In-grid dropdowns are handled natively by jspreadsheet.
    // ═══════════════════════════════════════════════════════════════════
    filterDropdown(event, data, reference) {
      this.dropdownRef = reference;
      const query = String(event.target.value || "").toLocaleLowerCase();
      const values = [...new Set((data || [])
        .filter(Boolean)
        .map(value => String(value))
        .filter(value => value.toLocaleLowerCase().includes(query)))];
      let options = "<p class='dp'>-&gt;&lt;-</p>";
      values.forEach(value => {
        const escapedValue = value
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");
        options += "<p class='dp'>" + escapedValue + "</p>";
      });
      const empty = values.length === 0;
      if (this.$refs.dropdown) {
        this.$refs.dropdown.innerHTML = options;
        event.target.parentNode.appendChild(this.$refs.dropdown)
        this.showDropdown = !empty;
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: selectDropdown(event)
    // Click on a <p> option of the floating dropdown.
    // Only used for the project filter now — grid cell dropdowns are
    // handled natively by jspreadsheet.
    // ═══════════════════════════════════════════════════════════════════
    selectDropdown(event) {
      if (this.dropdownRef.type == "project") {
        this.filter.project = event.target.innerText
        this.showDropdown = false
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: generalClick(event)
    // Click outside the project dropdown input → close the dropdown.
    // (Multi-select bookkeeping from the old view is obsolete — the grid
    // manages its own selection.)
    // ═══════════════════════════════════════════════════════════════════
    generalClick(event) {
      if (event.target.className && event.target.className.includes && !event.target.className.includes("dropdown")) {
        this.showDropdown = false
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: exportView()
    // Exports the current grid as .xlsx with the currently visible
    // columns in their rendered order (the pinned Aktionen column is
    // excluded). An active column filter inside the grid is honored
    // via worksheet.results.
    // ═══════════════════════════════════════════════════════════════════
    exportView() {
      const exportCols = this.renderedColumns.filter(col => col.field !== '_aktionen');
      const rows = this.jobs.map(job => exportCols.map(col => this.cellValue(job, col)));
      exportJssView({
        filename: new Date().toJSON().split("T")[0] + "_auftraege.xlsx",
        headers: exportCols.map(col => col.title),
        columnWidths: exportCols.map(col => col.width),
        rows: rows,
        worksheet: this.jssInstance && this.jssInstance[0]
      });
    },

    // Called by the Spalten manager — applies and persists the column
    // order/visibility for the current mode's view.
    onColumnsChange({ order, hidden }) {
      this.viewSettings = Object.assign({}, this.viewSettings, {
        [this.viewKey]: { order: order, hidden: hidden }
      });
      CASP.saveViewSettings(this.viewKey, { order: order, hidden: hidden });
      this.renderGrid();
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: changeUser(job)
    // Employee assignment: extracts persnr from "persnr (name surname)"
    // and persists Mitarbeiternr + Firmenkurzel.
    // Kept 1:1 (also bound to JobModal @changeUser).
    // ═══════════════════════════════════════════════════════════════════
    changeUser(job, previousValue) {
      this.selectedJob = false
      const rowIndex = this.jobs.findIndex(existingJob => existingJob && job && existingJob.id == job.id)
      if (rowIndex < 0) return
      const row = this.jobs[rowIndex]
      const persnr = extractPersnr(job.Mitarbeiternr)
      if (persnr) {
        const employee = this.employeeReadinessByPersnr[persnr] || {}
        const blockedForLocation = (employee.blockedEinsatzortCodes || [])
          .map(code => String(code).trim())
          .includes(String(row.Einsatzort_Code || '').trim())
        if (employee.pendingApproval || blockedForLocation) {
          job.Mitarbeiternr = previousValue || ''
          this.showBanner(employee.pendingApproval
            ? 'Mitarbeiter wartet auf Freigabe durch einen internen Admin'
            : 'Mitarbeiter ist für diesen Einsatzort gesperrt', 'error')
          return
        }
      }
      let changes = { Mitarbeiternr: persnr }
      // Override Firmenkurzel with the selected employee's Firmenkurzel (if available)
      if (this.employeeFirmenkurzelMap[persnr]) {
        row.Firmenkurzel = this.employeeFirmenkurzelMap[persnr]
        changes.Firmenkurzel = row.Firmenkurzel
      }
      row.Mitarbeiternr = job.Mitarbeiternr
      if (row.new) {
        this.syncJobToRow(rowIndex)
        return
      }
      this.changeMultipleAttributes(row, changes, (res) => {
        const liveRowIndex = this.jobs.findIndex(existingJob => existingJob === row)
        if (liveRowIndex < 0) return
        if (applyEmployeeAssignmentResponse(row, res, persnr)) {
          this.syncJobToRow(liveRowIndex)
        }
      })
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: getPresets()
    // Loads companies, servicetypes, contracts and employees for the
    // dropdown sources. Re-renders the grid if it is already up so the
    // dropdown columns pick up the sources.
    // ═══════════════════════════════════════════════════════════════════
    getPresets() {
      let vm = this
      CASP.getPresets(this.token, (res) => {
        if (res) {
          vm.allCompanies = res.companies
          vm.allServicetypes = res.Leistungsart_Codes
          vm.allContracts = res.contracts
          vm.allEmployees = []
          vm.employeeFirmenkurzelMap = {}
          vm.employeeReadinessByPersnr = {}
          Object.keys(res.employees).forEach((el) => {
            const employee = res.employees[el]
            const displayString = el + " (" + employee.name + " " + employee.surname + ")"
            vm.allEmployees.push(displayString)
            vm.employeeFirmenkurzelMap[el] = employee.Firmenkurzel
            vm.employeeReadinessByPersnr[el] = employee
          })
          if (vm.jssInstance) vm.renderGrid()
        }
      })
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: onChangedInput(job, column, calledFromMultisave)
    // Field-level save logic incl. the coupled-field rules:
    //   - Datum_von → WT is derived from the date
    //   - T_N="N" → Datum_bis = Datum_von + 1, else Datum_bis = Datum_von
    //   - Soll_Von > Soll_Bis → Datum_bis = Datum_von + 1
    //   - Halle/Ebene/Gang/Stand → Pos generation (Messestw)
    // Kept 1:1 — the multi-select guard was removed; bulk application is
    // handled by handleCellChange() which calls this per affected row.
    // ═══════════════════════════════════════════════════════════════════
    onChangedInput(job, column, calledFromMultisave = false) {
      if (column == "Datum_von") {
        job.WT = weekdayFromDate(job.Datum_von);
      }

      if ((column == "T_N" && job.Datum_von) || (column == "Datum_von" && job.T_N)) {
        job.T_N = job.T_N.toUpperCase();
        if (job.T_N == "N") {
          let date = new Date(job.Datum_von)
          date.setDate(date.getDate() + 1)
          job.Datum_bis = date.toISOString().split("T")[0]
        } else {
          job.Datum_bis = job.Datum_von
        }
        this.changeMultipleAttributes(job, {
          T_N: job.T_N,
          Datum_von: job.Datum_von,
          Datum_bis: job.Datum_bis,
          ...(column == "Datum_von" ? { WT: job.WT } : {})
        })
        return
      }
      if (column == "Datum_von") {
        this.changeMultipleAttributes(job, {
          Datum_von: job.Datum_von,
          WT: job.WT
        })
        return
      }
      if (column == "Soll_Von" && job.Datum_von && job.Soll_Bis || column == "Soll_Bis" && job.Datum_von && job.Soll_Bis) {
        let date = new Date(job.Datum_von)
        if (job.Soll_Von > job.Soll_Bis) {
          date.setDate(date.getDate() + 1)
          let changes = {
            Datum_bis: date.toISOString().split("T")[0]
          }
          job.Datum_bis = changes.Datum_bis
          changes[column] = job[column]
          this.changeMultipleAttributes(job, changes)
        } else {
          let changes = {
            Datum_bis: job.Datum_von,
          }
          job.Datum_bis = changes.Datum_bis
          changes[column] = job[column]
          this.changeMultipleAttributes(job, changes)
        }
      }
      else if (["Halle", "Ebene", "Gang", "Stand"].includes(column)) {
        this.generatePosition(job);
        this.changeMultipleAttributes(job, { [column]: job[column], Pos: job.Pos });
      }
      else {
        this.changeJob(job, column)
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // Functions: changeJob / changeMultipleAttributes
    // API save of one / several fields. No-op for new (unsaved) rows —
    // their values only live in the local job object until createJob().
    // Kept 1:1.
    // ═══════════════════════════════════════════════════════════════════
    changeJob(job, column) {
      if (job.new) return;
      let vm = this
      CASP.changeJob(this.token, job.id, { [column]: job[column] }, (res) => {
        if (res && res.status === "success") {
          vm.rowHighlighter.mark(res.id || job.id)
        } else if (res && res.error) {
          vm.showBanner(res.error, "error")
        }
      })
    },
    changeMultipleAttributes(job, changes, onSuccess) {
      if (job.new) return;
      let vm = this
      CASP.changeJob(this.token, job.id, changes, (res) => {
        if (res && res.status === "success") {
          if (onSuccess) onSuccess(res)
          vm.rowHighlighter.mark(res.id || job.id)
        } else if (res && res.error) {
          vm.showBanner(res.error, "error")
        }
      })
    },

    deleteAllNewJobs() {
      this.jobs = this.jobs.filter(job => !job.new)
      this.renderGrid()
    },
    async saveAllNewJobs() {
      let newJobs = this.jobs.filter(job => job.new)
      for (let i = 0; i < newJobs.length; i++) {
        try {
          await this.createJob(newJobs[i])
        } catch (e) {
          // Stop on first failure (same as the old view) — the error
          // banner was already shown by createJob.
          break
        }
      }
      this.renderGrid()
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: createJob(job)  (double-click on a green row)
    // Validates mandatory fields and persists a new job via API.
    // Kept 1:1.
    // ═══════════════════════════════════════════════════════════════════
    createJob(job) {
      return new Promise((resolve, reject) => {
        if (job.new) {
          let missing = []
          if (!job.Ebene) {
            if (job.Zeiterf_Buch_Blattname == "MESSESTW") {
              missing.push("Ebene")
            } else {
              job.Ebene = "0"
            }
          }
          if (!job.Zähler_Anzahl) missing.push("Zähler_Anzahl")
          if (missing.length > 0) {
            this.showBanner(missing.join(" und ") + " müssen ausgefüllt sein", "error")
            reject()
            return
          }
          let vm = this;
          CASP.createJob(this.token, job, (res) => {
            if (res.error) {
              vm.showBanner(res.error, "error")
              reject()
            } else {
              vm.jobs[vm.jobs.indexOf(job)] = res
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: addJob()  ("Job hinzufügen" button)
    // Adds a new empty row at the top so it is immediately visible.
    // ═══════════════════════════════════════════════════════════════════
    addJob() {
      this.jobs.unshift({
        new: true,
        id: "new" + this.newId++,
        Zeiterf_Buch_Blattname: this.currentMode.toUpperCase()
      })
      this.renderGrid()
    },

    getUsers() {
      let vm = this;
      CASP.getUsers(this.token, (res) => {
        if (res) {
          vm.allUsers = res;
        }
      });
    },

    formatFloat(value) {
      if (value === null || value === undefined || value === '') return value;
      let formatted = parseFloat(value).toFixed(2).replace('.', ',');
      if (parseFloat(value) < 10 && parseFloat(value) >= 0) {
        formatted = '0' + formatted;
      }
      return formatted;
    },
    generatePosition(job) {
      if (this.currentMode !== 'Messestw' && job.Zeiterf_Buch_Blattname !== 'MESSESTW') return;
      let pos = "";
      if (job.Halle) pos = `Halle ${job.Halle}`;
      if (job.Ebene) pos += `.0${job.Ebene}`;
      if (job.Stand) pos += ` Stand ${job.Gang}${job.Stand}`;
      job.Pos = pos;
    },
    printPage() {
      this.showActions = false
      setTimeout(() => { print() }, 500)
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: setContract / setLocation / setPlace
    // Dependent field logic (contract → location → place), incl. saving
    // the associated *_Code fields. Kept 1:1, with guards for values
    // that don't match a contract/location/place (e.g. cleared cells).
    // ═══════════════════════════════════════════════════════════════════
    setContract(job, contract) {
      let contractData = this.allContracts.find(c =>
        String(c.name || "").trim() == String(contract || "").trim()
      )
      if (!contractData) {
        job.Vertragsbeschreibung = contract
        this.changeJob(job, "Vertragsbeschreibung")
        return
      }
      job.Vertragsbeschreibung = contractData.name
      job.Belegnr = contractData.code
      if (contractData.debitor) {
        job.Debitorname = contractData.debitor.unternehmensname || contractData.debitor.name || ""
        job.Debitornr = contractData.debitor.navision_nr || ""
      }
      const tariffCategories = Array.isArray(contractData.tariffCategories)
        ? contractData.tariffCategories
        : []
      if (tariffCategories.length > 0 && !tariffCategories.includes(job.Rubrikencode)) {
        job.Rubrikencode = tariffCategories[0]
      }
      if (contractData.locations.length == 1) {
        this.setLocation(job, contractData.locations[0].name)
      } else {
        this.changeMultipleAttributes(job, {
          Belegnr: job.Belegnr,
          ...(tariffCategories.length > 0 ? { Rubrikencode: job.Rubrikencode } : {}),
          Einsatzort_Code: "",
          Einsatzstelle_Code: ""
        })
        job.Einsatzort_Beschreibung = ""
        job.Einsatzort_Code = ""
        job.Einsatzstelle_Beschreibung = ""
        job.Einsatzstelle_Code = ""
      }
    },
    setLocation(job, location) {
      let contractData = this.findContractForJob(job)
      let locationData = contractData && contractData.locations.find(l => l.name == location)
      if (!locationData) {
        job.Einsatzort_Beschreibung = location
        this.changeJob(job, "Einsatzort_Beschreibung")
        return
      }
      job.Einsatzort_Beschreibung = locationData.name
      job.Einsatzort_Code = locationData.code

      if (locationData.places.length == 1) {
        this.setPlace(job, locationData.places[0].name)
      } else {
        this.changeMultipleAttributes(job, {
          Belegnr: job.Belegnr,
          Einsatzort_Beschreibung: job.Einsatzort_Beschreibung,
          Einsatzort_Code: job.Einsatzort_Code,
          Einsatzstelle_Beschreibung: "",
          Einsatzstelle_Code: "",
          Rubrikencode: job.Rubrikencode
        })
        job.Einsatzstelle_Beschreibung = ""
        job.Einsatzstelle_Code = ""
      }
    },
    setPlace(job, place) {
      let contractData = this.findContractForJob(job)
      let locationData = contractData && contractData.locations.find(l => l.code == job.Einsatzort_Code)
      let placeData = locationData && locationData.places.find(p => p.name == place)
      if (!placeData) {
        job.Einsatzstelle_Beschreibung = place
        this.changeJob(job, "Einsatzstelle_Beschreibung")
        return
      }
      job.Einsatzstelle_Beschreibung = placeData.name
      job.Einsatzstelle_Code = placeData.code
      this.changeMultipleAttributes(job, {
        Belegnr: job.Belegnr,
        Einsatzort_Beschreibung: job.Einsatzort_Beschreibung,
        Einsatzort_Code: job.Einsatzort_Code,
        Einsatzstelle_Beschreibung: job.Einsatzstelle_Beschreibung,
        Einsatzstelle_Code: job.Einsatzstelle_Code,
        Rubrikencode: job.Rubrikencode
      })
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: getJobs()
    // Loads jobs via API for the current mode + filters, then renders
    // the grid. Sends the new filter to the websocket as well.
    // ═══════════════════════════════════════════════════════════════════
    getJobs() {
      clearTimeout(this.tableFilterTimer);
      this.tableFilterTimer = null;
      this.loading = true;
      let vm = this;
      this.filter.Zeiterf_Buch_Blattname = this.currentMode.toUpperCase()
      if (["Global", "App-Ansicht"].includes(this.currentMode)) {
        delete this.filter.Zeiterf_Buch_Blattname
      }
      this.sendSocketFilter();
      this.jobs = []
      const requestFilter = Object.assign({}, this.filter, { columnFilters: this.tableFilters });
      const dispatchedSnapshot = {
        mode: this.currentMode,
        project: requestFilter.project || '',
        start: requestFilter.start || '',
        end: requestFilter.end || ''
      };
      CASP.getAdminJobs(
        this.token,
        requestFilter,
        (res) => {
          vm.queryCount++;
          if (res && res.meta) vm.meta = res.meta
          vm.jobs = (res && res.jobs) ? res.jobs : []
          vm.searched = true;
          vm.loading = false;
          vm.renderGrid()
          if (res && (res.jobs || res.meta)) vm.searchSnapshot = dispatchedSnapshot;
          vm.rowHighlighter.apply();
        }
      );
    },

    updateTableFilters(filters) {
      this.tableFilters = filters;
      clearTimeout(this.tableFilterTimer);
      this.tableFilterTimer = setTimeout(() => {
        this.tableFilterTimer = null;
        this.getJobs();
      }, 150);
    },

    sendSocketFilter() {
      if (!this.connection || this.connection.readyState !== WebSocket.OPEN) return;
      this.connection.send(JSON.stringify({ type: "init", token: this.token, filter: this.filter }));
    },

    // ═══════════════════════════════════════════════════════════════════
    // Function: startSocket()
    // Websocket for live updates (checkin / update events).
    // NOTE: the old view called an undefined showCheckin() which crashed
    // the handler — implemented here as a banner notification.
    // ═══════════════════════════════════════════════════════════════════
    startSocket() {
      const vm = this
      this.connection = new WebSocket(process.env.VUE_APP_WS_URL + '/updates')
      this.connection.onopen = function (event) {
        vm.sendSocketFilter()
      }
      this.connection.onmessage = function (event) {
        let data;
        try {
          data = JSON.parse(event.data)
        } catch (error) {
          return
        }
        if (data.type === "checkin") {
          vm.showCheckin(data.job)
          vm.updateJobInGrid(data.job, true)
        } else if (data.type == "update") {
          vm.updateJobInGrid(data.job, true)
        }
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: showCheckin(job)
    // Banner notification for a websocket checkin event (fixes the
    // missing method in the old view).
    // ═══════════════════════════════════════════════════════════════════
    showCheckin(job) {
      let name = job.Mitarbeitername || job.Mitarbeiternr || ""
      let where = job.Einsatzort_Beschreibung || job.Einsatzstelle_Beschreibung || ""
      this.showBanner(("Check-In: " + name + " " + where).trim(), "success")
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: updateJobInGrid(job, flash)
    // Replaces a job in this.jobs and refreshes its row in the grid.
    // flash=true highlights the row green for 1s (old view set job.new
    // briefly to flash the row).
    // ═══════════════════════════════════════════════════════════════════
    updateJobInGrid(job, flash) {
      for (let i = 0; i < this.jobs.length; i++) {
        if (this.jobs[i].id == job.id && !this.jobs[i].new) {
          this.jobs[i] = job
          this.syncJobToRow(i)
          if (flash) {
            this.rowHighlighter.mark(job.id);
          }
          break
        }
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: getDropdownSource(field, job)
    // Resolves the autocomplete source for a dropdown column.
    // With a job given (editor open / dependent fields): row-specific list.
    // Without a job (static column source): union of ALL possible values
    // plus all currently stored values — jspreadsheet renders a dropdown
    // cell blank when its value is not contained in the column source.
    // ═══════════════════════════════════════════════════════════════════
    getDropdownSource(field, job) {
      let base = [];
      if (field === "Einsatzort_Beschreibung" && job) {
        return this.getDependentDropdownSource(
          this.findLocationNamesForJob(job),
          job.Einsatzort_Beschreibung
        );
      }
      if (field === "Einsatzstelle_Beschreibung" && job) {
        return this.getDependentDropdownSource(
          this.findPlaceNamesForJob(job),
          job.Einsatzstelle_Beschreibung
        );
      }
      if (field === "Rubrikencode" && job) {
        const contract = this.findContractForJob(job);
        base = contract && Array.isArray(contract.tariffCategories)
          ? contract.tariffCategories
          : [];
      }
      switch (field) {
        case "Vertragsbeschreibung":
          base = this.findContractNames() || [];
          break;
        case "Einsatzort_Beschreibung":
          (Array.isArray(this.allContracts) ? this.allContracts : [])
            .forEach(c => (c.locations || []).forEach(l => base.push(l.name)));
          break;
        case "Einsatzstelle_Beschreibung":
          (Array.isArray(this.allContracts) ? this.allContracts : [])
            .forEach(c => (c.locations || []).forEach(l => (l.places || []).forEach(p => base.push(p.name))));
          break;
        case "Rubrikencode":
          if (!job) {
            (Array.isArray(this.allContracts) ? this.allContracts : [])
              .forEach(c => (c.tariffCategories || []).forEach(category => base.push(category)));
          }
          break;
        case "Firmenkurzel":
          base = this.allCompanies || [];
          break;
        case "Leistungsart_Code":
          base = this.allServicetypes || [];
          break;
        case "Mitarbeiternr":
          base = (Array.isArray(this.allEmployees) ? this.allEmployees : []).map(displayString => {
            const persnr = extractPersnr(displayString);
            const employee = this.employeeReadinessByPersnr[persnr] || {};
            return {
              id: displayString,
              name: displayString,
              tooltip: employeeReadinessTooltip(employee),
              disabled: employee.pendingApproval === true
            };
          });
          break;
      }
      // allEmployees etc. are still {} (initial data) until their API
      // call resolves — renderGrid can run before that, so guard here.
      if (!Array.isArray(base)) base = [];
      // Add currently stored values so existing data is always displayable
      const seen = new Set(base.map(value =>
        value && typeof value === 'object' ? value.id : String(value)
      ));
      const jobsForSource = field === "Rubrikencode" && job ? [job] : this.jobs;
      jobsForSource.forEach(j => {
        const v = j[field];
        if (v !== undefined && v !== null && v !== "" && v !== false && !seen.has(String(v))) {
          seen.add(String(v));
          base.push(String(v));
        }
      });
      return base;
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: buildColumnDefs()
    // Maps the views.json column definitions of the current mode to
    // internal column defs, prefixed by the Aktionen column.
    // ═══════════════════════════════════════════════════════════════════
    buildColumnDefs() {
      const defs = [{
        title: "Aktionen",
        field: "_aktionen",
        jssType: "text",
        readOnly: true,
        pinned: true,
        width: 200
      }];
      (this.modes[this.currentMode] || []).forEach(col => {
        const def = {
          title: col.name,
          field: col.column,
          width: (this.columnWidths && this.columnWidths[col.column]) || 110
        };
        if (col.type === "checkbox") def.jssType = "checkbox";
        else if (col.type === "date") {
          def.jssType = "text";
          def.dateField = true;
        } else def.jssType = "text";
        if (col.readonly) def.readOnly = true;
        if (DROPDOWN_FIELDS.includes(col.column)) {
          def.jssType = "dropdown";
          def.autocomplete = true;
        }
        defs.push(def);
      });
      // Apply the user's saved column order/visibility for this mode
      return applyColumnSettings(defs, this.viewSettings[this.viewKey]);
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: cellValue(job, col)
    // Maps a job field to the raw grid cell value.
    // ═══════════════════════════════════════════════════════════════════
    cellValue(job, col) {
      if (col.field === "_aktionen") return "";
      if (col.jssType === "checkbox") {
        const v = job[col.field];
        return v === true || v === 1 || v === "true";
      }
      let v = ["Debitornr", "Debitorname"].includes(col.field)
        ? this.getContractDebitorValue(job, col.field)
        : job[col.field];
      if (col.dateField) return isoToDisplay(v);
      if (col.field === "Soll_Stunden" || col.field === "Ist_Stunden") {
        const f = this.formatFloat(v);
        return f === null || f === undefined ? "" : String(f);
      }
      if (v === undefined || v === null || v === false) return "";
      return String(v);
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: renderGrid()
    // Creates/destroys the jspreadsheet instance for the current mode.
    // Wires up all event handlers:
    //   - onchange → cell edits (incl. bulk apply on marked ranges)
    //   - onbeforechange → block dependent dropdowns without prerequisite
    //   - oncreatecell → new-row highlight, action buttons
    //   - onselection → track "marked" single-column multi-row ranges
    //   - onsort → resync this.jobs to the new row order
    //   - container click/dblclick → filters, copy, actions, row gestures
    // ═══════════════════════════════════════════════════════════════════
    renderGrid() {
      const container = this.$refs.spreadsheetContainer;
      if (!container) return;
      removeAutocompleteFilters(container);

      // Destroy existing instance + listeners
      if (this.appendOnlyRowLoadingCleanup) {
        this.appendOnlyRowLoadingCleanup();
        this.appendOnlyRowLoadingCleanup = null;
      }
      if (this.gridClickHandler) {
        container.removeEventListener('click', this.gridClickHandler);
        this.gridClickHandler = null;
      }
      if (this.gridDblClickHandler) {
        container.removeEventListener('dblclick', this.gridDblClickHandler);
        this.gridDblClickHandler = null;
      }
      if (container.spreadsheet) {
        try { jspreadsheet.destroy(container); } catch (e) { /* ignore */ }
      }
      container.innerHTML = '';
      this.jssInstance = null;
      this.markedRange = null;

      this.calculateColumnWidths();
      const cols = this.buildColumnDefs();
      this.renderedColumns = cols;
      if (this.sortState) {
        const sortColumn = cols.find(col => col.field === this.sortState.field);
        if (sortColumn) {
          this.jobs = sortJssRows(
            this.jobs,
            job => this.cellValue(job, sortColumn),
            this.sortState.direction
          );
        }
      }
      const data = this.jobs.map(job => cols.map(col => this.cellValue(job, col)));

      const vm = this;

      const columns = cols.map(col => {
        const colDef = {
          title: col.title,
          width: col.width,
          type: col.jssType
        };
        if (col.readOnly) colDef.readOnly = true;
        if (col.jssType === "dropdown") {
          colDef.autocomplete = true;
          // Static source (also acts as base for the filter function)
          colDef.source = vm.getDropdownSource(col.field, null);
          // Dependent dropdowns: resolve the source per row at edit time.
          if (DEPENDENT_DROPDOWN_FIELDS.includes(col.field)) {
            colDef.filter = (el, cell, x, y, source) => {
              const job = vm.jobs[y];
              return vm.getDropdownSource(col.field, job) || [];
            };
          }
        }
        return colDef;
      });

      this.jssInstance = jspreadsheet(container, {
        onchange: (instance, cell, colIndex, rowIndex, newValue, oldValue) => {
          vm.handleCellChange(colIndex, rowIndex, newValue, oldValue);
        },
        onbeforechange: (instance, cell, colIndex, rowIndex, newValue) => {
          if (vm.suppressChange) return undefined;
          const col = vm.renderedColumns[colIndex];
          const job = vm.jobs[rowIndex];
          if (!col || !job) return undefined;
          let dateValue;
          if (col.dateField) {
            dateValue = formatDateInput(newValue);
            if (dateValue === null || !isValidDisplayDate(dateValue)) {
              vm.showBanner("Bitte ein gültiges Datum im Format TT.MM.JJJJ eingeben", "error");
              return false;
            }
          }
          // Einsatzort requires a contract, Einsatzstelle requires a location
          // (old view rendered these cells as non-editable spans)
          if (col.field === "Einsatzort_Beschreibung" && !job.Vertragsbeschreibung) {
            vm.showBanner("Bitte zuerst eine Vertragsbeschreibung auswählen", "error");
            return false;
          }
          if (col.field === "Einsatzstelle_Beschreibung" && !job.Einsatzort_Beschreibung) {
            vm.showBanner("Bitte zuerst einen Einsatzort auswählen", "error");
            return false;
          }
          return col.dateField ? dateValue : undefined;
        },
        oncreateeditor: (instance, cell, colIndex, rowIndex) => {
          const col = vm.renderedColumns[colIndex];
          if (!col) return;
          if (col.dateField) {
            const editor = cell.querySelector('input, textarea');
            if (editor) editor.addEventListener('input', () => formatDateEditor(editor));
          }
          if (col.field === 'Mitarbeiternr') {
            const job = vm.jobs[rowIndex];
            const locationCode = String(job && job.Einsatzort_Code || '').trim();
            // The jsuites dropdown is created right after this hook. Once it
            // exists, disable the items whose employee is blocked for THIS
            // row's einsatzort (the column source itself is shared).
            setTimeout(() => {
              const dropdownEl = cell.querySelector('.jdropdown');
              const dropdown = dropdownEl && dropdownEl.dropdown;
              if (!dropdown || !Array.isArray(dropdown.items)) return;
              dropdown.items.forEach(item => {
                const persnr = extractPersnr(item.data && item.data.id);
                const employee = persnr ? vm.employeeReadinessByPersnr[persnr] : null;
                const blockedForLocation = employee && !employee.pendingApproval && locationCode &&
                  (employee.blockedEinsatzortCodes || [])
                    .map(code => String(code).trim()).includes(locationCode);
                if (blockedForLocation) {
                  item.data.disabled = true;
                  item.element.setAttribute('data-disabled', 'true');
                }
              });
            }, 0);
          }
        },
        oncreatecell: (instance, cell, colIndex, rowIndex, newValue) => {
          vm.handleCreateCell(instance, cell, colIndex, rowIndex, newValue);
        },
        onselection: (instance, x1, y1, x2, y2) => {
          // Track single-column multi-row selections as "marked" range.
          // A click inside the marked range (single cell) keeps it alive;
          // any selection outside clears it.
          if (x1 === x2 && y1 !== y2) {
            vm.markedRange = { col: x1, top: Math.min(y1, y2), bottom: Math.max(y1, y2) };
          } else if (vm.markedRange) {
            const inside = x1 === x2 && y1 === y2 && x1 === vm.markedRange.col &&
              y1 >= vm.markedRange.top && y1 <= vm.markedRange.bottom;
            if (!inside) vm.markedRange = null;
          }
        },
        onsort: (instance, colIndex, order, newOrder) => {
          const column = vm.renderedColumns[colIndex];
          if (!column || column.field === "_aktionen") return;
          vm.sortState = {
            field: column.field,
            direction: order === 1 ? "desc" : "asc"
          };
          // The worksheet contains only the first batch. Re-render from the
          // complete sorted array so future batches use the same order.
          vm.renderGrid();
        },
        worksheets: [{
          data: data.slice(0, 100),
          columns: columns,
          filters: true,
          tableOverflow: true,
          tableHeight: 'calc(100vh - 430px)',
          tableWidth: '100%',
          columnSorting: true,
          lazyLoading: true,
          defaultColAlign: 'left',
          wordWrap: true
        }]
      });
      const worksheet = this.jssInstance[0];
      this.appendOnlyRowLoadingCleanup = installAppendOnlyRowLoading(worksheet, {
        remainingRows: data.slice(100),
        appendRows: rows => rows.forEach(row => worksheet.insertRow(
          row,
          worksheet.rows.length - 1,
          false
        ))
      });
      // Keep the filter row below the sticky title row instead of
      // overlapping it (both would stick at top:0 otherwise).
      stickFilterRow(container);
      installAutocompleteFilters(container, this.jssInstance[0], this.renderedColumns, {
        serverSide: true,
        initialFilters: this.tableFilters,
        onFilterChange: filters => this.updateTableFilters(filters)
      });

      // ─── Container click handler ─────────────────────────────────
      this.gridClickHandler = (e) => {
        const ws = vm.jssInstance && vm.jssInstance[0];
        if (!ws) return;

        // Column filter icon: open on single click (CE default is double-click)
        if (e.target.classList.contains('jss_column_filter')) {
          const colIndex = e.target.getAttribute('data-x');
          if (colIndex !== null) {
            ws.openFilter(parseInt(colIndex));
          }
          return;
        }

        // Shift+click: copy cell value to clipboard
        if (e.shiftKey) {
          const cell = e.target.closest('td[data-x][data-y]');
          if (cell) {
            const colIndex = parseInt(cell.getAttribute('data-x'));
            const rowIndex = parseInt(cell.getAttribute('data-y'));
            const value = ws.getValueFromCoords(colIndex, rowIndex);
            if (value !== '' && value !== null && value !== undefined) {
              navigator.clipboard.writeText(String(value)).then(() => {
                vm.showBanner('Wert kopiert: ' + String(value).substring(0, 30), 'success');
              }).catch(() => {
                const textarea = document.createElement('textarea');
                textarea.value = String(value);
                document.body.appendChild(textarea);
                textarea.select();
                try { document.execCommand('copy'); } catch (err) { /* ignore */ }
                document.body.removeChild(textarea);
                vm.showBanner('Wert kopiert', 'success');
              });
            }
            e.preventDefault();
            return;
          }
        }

        // Action buttons inside the Aktionen column
        const btnClasses = ['jss-btn-copy', 'jss-btn-dismiss', 'jss-btn-trash', 'jss-btn-zaehlen', 'jss-btn-details', 'jss-btn-kontakt'];
        const btn = btnClasses.map(c => e.target.closest('.' + c)).find(b => b);
        if (btn) {
          const cell = btn.closest('td[data-x][data-y]');
          if (cell) {
            const rowIndex = parseInt(cell.getAttribute('data-y'));
            const job = vm.jobs[rowIndex];
            if (job) {
              if (btn.classList.contains('jss-btn-copy')) vm.duplicateJob(job);
              else if (btn.classList.contains('jss-btn-dismiss')) vm.dismissJob(job);
              else if (btn.classList.contains('jss-btn-trash')) vm.trashJob(job);
              else if (btn.classList.contains('jss-btn-zaehlen')) vm.updateLfd(job);
              else if (btn.classList.contains('jss-btn-details')) vm.selectedJob = job;
              else if (btn.classList.contains('jss-btn-kontakt')) vm.contactDetails = job;
            }
          }
          e.stopPropagation();
          return;
        }

        const cell = e.target.closest('td[data-x][data-y]');
        if (!cell) return;
        const rowIndex = parseInt(cell.getAttribute('data-y'));
        const job = vm.jobs[rowIndex];
        if (!job) return;

        // STRG+click: duplicate row / ALT+click: dismiss row (old gestures)
        if (e.ctrlKey) {
          vm.duplicateJob(job);
          e.preventDefault();
          return;
        }
        if (e.altKey) {
          vm.dismissJob(job);
          e.preventDefault();
          return;
        }

        // Click on an already-selected cell → open editor
        // (mirrors the old view where every cell was a visible input)
        if (cell.classList.contains('highlight') && !ws.edition) {
          const colIndex = parseInt(cell.getAttribute('data-x'));
          const col = vm.renderedColumns[colIndex];
          if (col && !col.readOnly && col.jssType !== 'checkbox' && col.field !== '_aktionen') {
            ws.openEditor(cell, undefined, e);
          }
        }
      };
      container.addEventListener('click', this.gridClickHandler);

      // ─── Container dblclick handler ──────────────────────────────
      // Double-click on a green (new) row saves it to Navision.
      this.gridDblClickHandler = (e) => {
        const ws = vm.jssInstance && vm.jssInstance[0];
        const cell = e.target.closest('td[data-x][data-y]');
        if (!cell) return;
        const rowIndex = parseInt(cell.getAttribute('data-y'));
        const job = vm.jobs[rowIndex];
        if (job && job.new) {
          if (ws && ws.edition) {
            try { ws.closeEditor(cell, false); } catch (err) { /* ignore */ }
          }
          vm.createJob(job).then(() => vm.renderGrid());
        }
      };
      container.addEventListener('dblclick', this.gridDblClickHandler);
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: handleCreateCell(instance, cell, colIndex, rowIndex, newValue)
    //   - new (unsaved) rows → green background
    //   - Aktionen column → buttons
    // ═══════════════════════════════════════════════════════════════════
    handleCreateCell(instance, cell, colIndex, rowIndex, newValue) {
      const col = this.renderedColumns[colIndex];
      const job = this.jobs[rowIndex];
      if (!col || !job) return;

      if (job.new) {
        cell.style.backgroundColor = '#bbf7d0';
      }

      if (col.field === '_aktionen') {
        cell.classList.add('jss-nowrap');
        cell.innerHTML = this.actionButtonsHtml(job, rowIndex);
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: actionButtonsHtml(job, rowIndex)
    // Buttons of the Aktionen column:
    //   K     → duplicate row
    //   L     → dismiss new row
    //   trash → move to trashcan (admin, existing jobs only)
    //   Zählen→ sequential Lfd_Nr (first row only, like the old view)
    //   Details → JobModal
    //   Kontakt → ContactDetails
    // ═══════════════════════════════════════════════════════════════════
    actionButtonsHtml(job, rowIndex) {
      // Styling comes from the .admin-shell .jss-btn-* rules in admin.css
      // plus the scoped :deep() rules below — no inline styles.
      let html = '<button type="button" class="admin-button--secondary admin-button--sm jss-btn-copy" title="Zeile kopieren (STRG+Klick)">K</button>';
      if (job.new) {
        html += ' <button type="button" class="admin-button--danger admin-button--sm jss-btn-dismiss" title="Zeile aus Ansicht löschen (ALT+Klick)">L</button>';
      }
      if (!job.new && this.stats.permissions.admin) {
        html += ' <button type="button" class="admin-button--danger admin-button--sm jss-btn-trash" title="In Papierkorb verschieben"><i class="fa fa-trash"></i></button>';
      }
      if (rowIndex === 0 && this.hasLfdColumn) {
        html += ' <button type="button" class="admin-button--secondary admin-button--sm jss-btn-zaehlen" title="Lfd Nr. durchnummerieren">Zählen</button>';
      }
      html += ' <button type="button" class="admin-button--secondary admin-button--sm jss-btn-details" title="Auftragsdetails">Details</button>';
      if (job.Mitarbeiternr && !job['Ist_Zeiten_geprüft']) {
        html += ' <button type="button" class="admin-button--secondary admin-button--sm jss-btn-kontakt" title="Kontaktdaten des Mitarbeiters">Kontakt</button>';
      }
      return html;
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: handleCellChange(colIndex, rowIndex, newValue, oldValue)
    // Central cell change handler. If the edited cell belongs to a
    // "marked" range (single column, multiple rows selected), the value
    // is applied to all marked rows — replacement for the old view's
    // marked-cells + Enter behaviour.
    // ═══════════════════════════════════════════════════════════════════
    handleCellChange(colIndex, rowIndex, newValue, oldValue) {
      if (this.suppressChange) return;
      const col = this.renderedColumns[colIndex];
      if (!col || col.field === '_aktionen') return;

      const ws = this.jssInstance && this.jssInstance[0];

      // Rows to apply to: the marked range if the edited cell is part of it
      let rows = [rowIndex];
      if (this.markedRange && this.markedRange.col === colIndex &&
        rowIndex >= this.markedRange.top && rowIndex <= this.markedRange.bottom) {
        rows = [];
        for (let y = this.markedRange.top; y <= this.markedRange.bottom; y++) rows.push(y);
        this.markedRange = null;
      } else {
        // Fallback: current selection still spanning multiple rows
        const sel = this.getSelectedRowsForColumn(colIndex, rowIndex);
        if (sel.length > 1) rows = sel;
      }

      rows.forEach(y => {
        const job = this.jobs[y];
        if (!job) return;
        if (y !== rowIndex && ws) {
          this.suppressChange = true;
          ws.setValueFromCoords(colIndex, y, newValue, true);
          this.suppressChange = false;
        }
        this.applyValueToJob(job, col, newValue);
      });
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: getSelectedRowsForColumn(colIndex, rowIndex)
    // Returns all rows of the current selection if it covers a single
    // column and contains rowIndex. Falls back to highlighted DOM cells.
    // ═══════════════════════════════════════════════════════════════════
    getSelectedRowsForColumn(colIndex, rowIndex) {
      const rows = new Set([rowIndex]);
      const ws = this.jssInstance && this.jssInstance[0];
      if (ws && ws.getSelection) {
        try {
          const sel = ws.getSelection();
          if (sel && sel[0] === colIndex && sel[2] === colIndex) {
            for (let y = Math.min(sel[1], sel[3]); y <= Math.max(sel[1], sel[3]); y++) rows.add(y);
            return [...rows];
          }
        } catch (e) { /* ignore */ }
      }
      const container = this.$refs.spreadsheetContainer;
      if (container) {
        container.querySelectorAll('td.highlight[data-x="' + colIndex + '"]').forEach(td => {
          rows.add(parseInt(td.getAttribute('data-y')));
        });
      }
      return [...rows];
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: applyValueToJob(job, col, value)
    // Applies a cell value to the job object and triggers the matching
    // save logic (dependent dropdowns, employee assignment, coupled
    // fields). New rows are updated locally only — changeJob and
    // changeMultipleAttributes no-op for them.
    // ═══════════════════════════════════════════════════════════════════
    applyValueToJob(job, col, value) {
      const field = col.field;
      if (col.dateField) {
        if (!isValidDisplayDate(value)) {
          this.showBanner("Bitte ein gültiges Datum im Format TT.MM.JJJJ eingeben", "error");
          return;
        }
        value = displayToIso(value);
      }
      if (col.jssType === 'checkbox') {
        job[field] = (value === true || value === 'true' || value === 1);
        this.onChangedInput(job, field, true);
      } else {
        const previousValue = job[field];
        job[field] = value;
        if (field === 'Vertragsbeschreibung') {
          this.setContract(job, value);
        } else if (field === 'Einsatzort_Beschreibung') {
          this.setLocation(job, value);
        } else if (field === 'Einsatzstelle_Beschreibung') {
          this.setPlace(job, value);
        } else if (field === 'Mitarbeiternr') {
          this.changeUser(job, previousValue);
        } else {
          this.onChangedInput(job, field, true);
        }
      }
      // Refresh cells of fields that may have been changed as a side
      // effect (Datum_bis, Pos, *_Code, Firmenkurzel, Vertragsbeschreibung)
      this.syncJobToRow(this.jobs.indexOf(job));
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: syncJobToRow(rowIndex) / syncColumnCells(field)
    // Writes the current job values back into the rendered grid cells
    // without triggering onchange, and rebuilds the Aktionen buttons.
    // ═══════════════════════════════════════════════════════════════════
    syncJobToRow(rowIndex) {
      const ws = this.jssInstance && this.jssInstance[0];
      const job = this.jobs[rowIndex];
      if (!ws || !job) return;
      this.renderedColumns.forEach((col, x) => {
        if (col.field === '_aktionen') {
          this.renderActionCell(rowIndex);
          return;
        }
        const val = this.cellValue(job, col);
        const current = ws.getValueFromCoords(x, rowIndex);
        if (String(current === null || current === undefined ? '' : current) !== String(val)) {
          // Dropdown cells render blank when the value is not in the
          // column source — make sure it is there before writing.
          if (col.jssType === 'dropdown' && val !== '') {
            const src = ws.options.columns[x].source;
            if (src && !src.includes(val)) src.push(val);
          }
          this.suppressChange = true;
          ws.setValueFromCoords(x, rowIndex, val, true);
          this.suppressChange = false;
        }
      });
    },
    syncColumnCells(field) {
      const ws = this.jssInstance && this.jssInstance[0];
      if (!ws) return;
      const x = this.renderedColumns.findIndex(c => c.field === field);
      if (x < 0) return;
      this.jobs.forEach((job, y) => {
        const val = this.cellValue(job, this.renderedColumns[x]);
        const current = ws.getValueFromCoords(x, y);
        if (String(current === null || current === undefined ? '' : current) !== String(val)) {
          this.suppressChange = true;
          ws.setValueFromCoords(x, y, val, true);
          this.suppressChange = false;
        }
      });
    },
    renderActionCell(rowIndex) {
      const container = this.$refs.spreadsheetContainer;
      const x = this.renderedColumns.findIndex(c => c.field === '_aktionen');
      const job = this.jobs[rowIndex];
      if (!container || x < 0 || !job) return;
      const td = container.querySelector('td[data-x="' + x + '"][data-y="' + rowIndex + '"]');
      if (td) {
        td.classList.add('jss-nowrap');
        td.innerHTML = this.actionButtonsHtml(job, rowIndex);
      }
    },

    // ═══════════════════════════════════════════════════════════════════
    // NEW: showBanner(text, mode)
    // Temporary banner notification.
    // ═══════════════════════════════════════════════════════════════════
    showBanner(text, mode = 'success') {
      this.bannerText = text;
      this.bannerMode = mode;
      setTimeout(() => { this.bannerText = ''; }, 3000);
    }
  },

  mounted: function () {
    let vm = this
    window.vm = vm

    document.getElementById("mainspinner").style.display = "none";

    CASP.isAuthenticated(this.token, (auth) => {
      if (!auth) {
        window.location = "/admin/login";
      } else {
        this.getPresets();
        this.getUsers();
        this.rowHighlighter = createRowHighlighter({
          getContainer: () => this.$refs.spreadsheetContainer,
          getRows: () => this.jobs
        });
        CASP.getViewSettings((status, res) => {
          if (status === 200 && res) {
            vm.viewSettings = res;
            if (vm.jssInstance) vm.renderGrid();
          }
        });
        this.getJobs();
        this.startSocket();
        CASP.getStats((status, response) => {
          if (status == 200) {
            vm.stats = response
            // Re-render so permission-gated buttons (trash) appear
            if (vm.jobs.length > 0) {
              vm.renderGrid();
            }
          }
        })
      }
    });
  },

  beforeUnmount() {
    clearTimeout(this.tableFilterTimer);
    if (this.rowHighlighter) this.rowHighlighter.clear();
    if (this.appendOnlyRowLoadingCleanup) {
      this.appendOnlyRowLoadingCleanup();
      this.appendOnlyRowLoadingCleanup = null;
    }
    const container = this.$refs.spreadsheetContainer;
    if (container) {
      removeAutocompleteFilters(container);
      if (this.gridClickHandler) {
        container.removeEventListener('click', this.gridClickHandler);
      }
      if (this.gridDblClickHandler) {
        container.removeEventListener('dblclick', this.gridDblClickHandler);
      }
      if (container.spreadsheet) {
        try { jspreadsheet.destroy(container); } catch (e) { /* ignore */ }
      }
      container.innerHTML = '';
    }
    if (this.connection) {
      try { this.connection.close(); } catch (e) { /* ignore */ }
    }
  }
};
</script>

<style scoped>
/* jspreadsheet-ce v5 assigns its visual arrows opposite to the sort
   direction used by its context-menu actions. */
.jss-container :deep(.jss_worksheet > thead > tr > td.arrow-up) {
  background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3Cpath d='M7 10l5 5 5-5H7z' fill='gray'/%3E%3C/svg%3E");
}

.jss-container :deep(.jss_worksheet > thead > tr > td.arrow-down) {
  background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3Cpath d='M7 14l5-5 5 5H7z' fill='gray'/%3E%3C/svg%3E");
}

#printtest {
  display: none;
}

.project-filter-dropdown {
  left: 0;
  top: 100%;
  width: max-content;
  min-width: 100%;
  max-width: min(42rem, calc(100vw - 1rem));
  white-space: nowrap;
  overflow-x: auto;
}

.project-filter-dropdown .dp {
  margin: 0;
  white-space: nowrap;
}

.marked {
  background: yellowgreen;
}

.jss-container {
  width: 100%;
  overflow: visible;
  text-align: left;
}

/* Header text black, left-aligned like the data cells */
.jss-container :deep(.jss_worksheet > thead > tr > td) {
  color: #000 !important;
  text-align: left;
}

/* All data fields left-aligned (the container's text-align would
   otherwise be inherited into the cells) */
.jss-container :deep(.jss_worksheet > tbody > tr > td) {
  text-align: left;
}

/* All items left-aligned, including the row-number column */
.jss-container :deep(.jss_worksheet > tbody > tr > td:first-child) {
  text-align: left;
}

/* Aktionen cells must never line-break. jspreadsheet keeps applying
   inline white-space:pre-wrap (wordWrap option and >200-char content),
   so !important is required; the class is re-added on every cell render. */
.jss-container :deep(.jss_worksheet td.jss-nowrap) {
  white-space: nowrap !important;
}

/* Override global tailwind.css checkbox hiding inside the grid.
   The global [type="checkbox"] rule uses appearance-none + w-0 and relies
   on a label::before pseudo-element, but jspreadsheet creates bare
   <input type="checkbox"> without a label, making them invisible. */
.jss-container :deep(.jss_worksheet input[type="checkbox"]) {
  appearance: auto;
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin: 0;
}

/* Ensure thead stays sticky inside the scrollable .jss_content container */
.jss-container :deep(.jss_content) {
  overflow: auto;
}

.jss-container :deep(.jss_worksheet > thead > tr > td) {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: #f3f4f6;
}

/* The filter row is a second thead row (its cells carry the class
   jss_column_filter) — without an offset it would stick at top:0
   directly on top of the title row and hide it on scroll.
   --jss-header-h is set by stickFilterRow() after each render. */
.jss-container :deep(.jss_worksheet > thead > tr.jss-filter-row > td) {
  top: var(--jss-header-h, 26px);
}

/* Neutral gray for selected/highlighted cells */
.jss-container :deep(.jss_worksheet .highlight),
.jss-container :deep(.jss_worksheet td.highlight),
.jss-container :deep(.jss_worksheet .highlight-selected),
.jss-container :deep(.jss_worksheet .selection),
.jss-container :deep(.jss_worksheet tr.selected > td) {
  background-color: #e5e7eb !important;
}

.jss-container :deep(.jss_worksheet > tbody > tr.selected > td:first-child) {
  background-color: #d1d5db !important;
}

/* Action buttons in grid cells — base colors come from the
   .admin-shell .jss-btn-* rules in admin.css; keep them compact here. */
.jss-container :deep(.jss-btn-copy),
.jss-container :deep(.jss-btn-dismiss),
.jss-container :deep(.jss-btn-trash),
.jss-container :deep(.jss-btn-zaehlen),
.jss-container :deep(.jss-btn-details),
.jss-container :deep(.jss-btn-kontakt) {
  min-height: 0;
  padding: 2px 6px;
  font-size: 12px;
  line-height: 1.4;
  margin: 1px;
  white-space: nowrap;
  cursor: pointer;
}

.jss-container :deep(.jss-btn-copy:hover),
.jss-container :deep(.jss-btn-dismiss:hover),
.jss-container :deep(.jss-btn-zaehlen:hover),
.jss-container :deep(.jss-btn-details:hover),
.jss-container :deep(.jss-btn-kontakt:hover) {
  background-color: #edf0f4 !important;
}

.jss-container :deep(.jss-btn-trash:hover) {
  background-color: #a92f2f !important;
}

tr {
  page-break-inside: avoid;
  line-height: 1;
}

button.search-button--pending {
  background-color: #22c55e;
  color: #fff;
}

button.search-button--pending:hover {
  background-color: #16a34a;
}

button.search-button--pending:focus {
  outline: 2px solid #86efac;
  outline-offset: 2px;
}

button.search-button--pending:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media print {
  #printtest {
    display: none;
  }

  button {
    display: none;
  }

  .jss-container {
    overflow: visible !important;
  }
}
</style>
